import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsDriver,
  UpdateNpsDriver,
  FiltersNpsDrivers
} from '@/Network/Types/Requests/NpsRequests'
import { NpsDriverResponse, ListNpsDriversResponse } from '@/Network/Types/Responses/NpsResponses'

export default class NpsDriverService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/drivers'
  }

  async create(payload: CreateNpsDriver): Promise<NpsDriverResponse> {
    const response = await request.post<NpsDriverResponse>(this.getCompletePath(), payload)
    return response.data
  }

  async update(driverId: number, payload: UpdateNpsDriver): Promise<NpsDriverResponse> {
    const response = await request.put<NpsDriverResponse>(
      `${this.getCompletePath()}/${driverId}`,
      payload
    )
    return response.data
  }

  async getById(driverId: number): Promise<NpsDriverResponse> {
    const response = await request.get<NpsDriverResponse>(`${this.getCompletePath()}/${driverId}`)
    return response.data
  }

  async toggleActive(driverId: number, companyId: number): Promise<NpsDriverResponse> {
    const response = await request.patch(
      `${this.getCompletePath()}/${driverId}/toggle-active?companyId=${companyId}`,
      {}
    )
    return response.data as NpsDriverResponse
  }

  async delete(driverId: number): Promise<void> {
    await request.delete(`${this.getCompletePath()}/${driverId}`)
  }

  async list(filters?: FiltersNpsDrivers): Promise<ListNpsDriversResponse> {
    try {
      const { data } = await request.get<ListNpsDriversResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
